import { StudentAnalysisReportCardPresenter } from './presenter';
import withStudentAnalysisReportState from '../withStudentAnalysisReportState';
export var StudentAnalysisReportCard = withStudentAnalysisReportState(StudentAnalysisReportCardPresenter);